
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getRoleList, delRole } from "@/api/api-basic";
import { getOptionList, optionKey } from "@/api/api-dict";
import roleInfo from "./components/role-info.vue";
import permissionMenu from "./components/permission-menu.vue";
import { State } from "vuex-class";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-role-info": roleInfo,
    "pi-permission-menu": permissionMenu
  }
})
export default class SystemConfigRole extends Vue {
  @State("sys") sys!: objAny;
  private total = 0;
  private privilege: objAny = {};
  private loading = false;
  private selectRolePkId = "";
  private formInline: objAny = {
    globalOrderBy: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    roleType: ""
  };
  private addModalTitle = "";
  private addModalShow = false;
  private autoModalTitle = i18n.t("role.autoConfig");
  private autoModalShow = false;

  // private softsystemList: object[] = [];
  private selectList: object[] = [];

  private roleTypeList: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    // {
    //   type: "selection",
    //   width: 60,
    //   align: "center"
    // },
    {
      title: i18n.t("role.thRoleName"),
      key: "thRoleName",
      minWidth: 80
    },
    {
      title: i18n.t("role.enRoleName"),
      key: "enRoleName",
      minWidth: 80
    },
    {
      title: i18n.t("role.roleName"),
      key: "roleName",
      minWidth: 80
    },
    {
      title: i18n.t("role.roleType"),
      key: "roleTypeName",
      minWidth: 80,
      slot: "roleName"
    },
    {
      title: i18n.t("role.roleDesc"),
      key: "roleDesc",
      minWidth: 120
    },
    {
      title: i18n.t("role.createUserName"),
      key: "createUserName",
      minWidth: 100
    },
    {
      title: i18n.t("role.createTime"),
      key: "createTime",
      minWidth: 160
    },
    {
      title: i18n.t("role.modifyTime"),
      key: "modifyTime",
      minWidth: 160
    },
    {
      title: i18n.t("operation"),
      slot: "action",
      minWidth: 120
    }
  ];

  private roleInfo: objAny = {};
  private permission: objAny = {};

  public selectItem(list: object[]) {
    this.selectList = list;
  }
  // public rowClassName(row: objAny): string {
  //   if (this.selectRolePkId == row.rolePkId) {
  //     return "role-row-class";
  //   } else {
  //     return "";
  //   }
  // }

  public addUser(): void {
    this.addModalTitle = i18n.t("role.addRole") + "";
    this.addModalShow = true;
    const data = {
      roleDesc: "",
      rolePkId: "",
      roleName: "",
      roleType: ""
    };
    this.selectRolePkId = "";
    if (!this.roleInfo.initData) {
      this.$nextTick(() => {
        this.roleInfo = this.$refs["roleInfo"];
        this.roleInfo.initData(data);
      });
    } else {
      this.roleInfo.initData(data);
    }

    // this.permission.initData(data);
  }
  public addUserSuccess() {
    this.addModalShow = false;
    this.getTableList();
  }
  public autoClick(item: objAny) {
    this.autoModalShow = true;
    this.selectRolePkId = item.rolePkId;
    if (!this.permission.initData) {
      this.$nextTick(() => {
        this.permission = this.$refs["permission"];
        this.permission.init(item);
      });
    } else {
      this.permission.init(item);
    }
  }
  public autoSuccess() {
    this.autoModalShow = false;
    this.getTableList();
  }
  public updataClick(item: objAny) {
    this.addModalTitle = i18n.t("role.upRole") + "";
    this.addModalShow = true;
    this.selectRolePkId = item.rolePkId;
    if (!this.roleInfo.initData) {
      this.$nextTick(() => {
        this.roleInfo = this.$refs["roleInfo"];
        this.roleInfo.initData(item);
      });
    } else {
      this.roleInfo.initData(item);
    }
  }

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public rowClick(row: objAny) {
    this.selectRolePkId = row.rolePkId;
    this.roleInfo.initData(row);
    this.permission.initData(row);
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    if (this.formInline.roleType == undefined) {
      this.formInline.roleType = "";
    }
    const ret = await getRoleList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      const arr: object[] = [];
      const defaultRole = ["1", "2", "3", "4"];
      ret.data.map((item: objAny) => {
        if (defaultRole.indexOf(item.rolePkId) != -1) {
          // roleType == 1 是管理员
          if (this.sys.userInfo.roleType != 1) {
            item._addDisabled = true;
          }
          item._disabled = true;
        }
        arr.push(item);
      });
      this.tableList = arr;
      // if (arr.length > 0) {
      //   let itemData: objAny = arr[0] ? arr[0] : {};
      //   arr.map((item: objAny) => {
      //     if (
      //       this.selectRolePkId !== "" &&
      //       this.selectRolePkId === item.rolePkId
      //     ) {
      //       itemData = item;
      //     }
      //   });
      //   this.rowClick(itemData);
      // }
    }
    this.loading = false;
  }

  async delUser(item: objAny): Promise<void> {
    const ret = await delRole({ roleIds: [item.rolePkId] });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess") + "");
      this.getTableList();
    }
  }

  async getOptionList(): Promise<void> {
    const ret = await getOptionList([optionKey.roleTypeObj]);
    this.roleTypeList = ret[optionKey.roleTypeObj];
  }

  mounted() {
    this.getOptionList();
    this.$nextTick(() => {
      this.roleInfo = this.$refs["roleInfo"];
      this.permission = this.$refs["permission"];
    });
    this.privilege = this.$route.meta.privilegeVoObj;
    this.getTableList();
  }
}
